module.exports = __webpack_public_path__ + "img/1508199229.efa306c2.jpg";